<template>
    <div class="materialInfo" v-loading="loading">
        <div class="materialInfo-header">
            <InfoHeader title="工单详情" @backPage="handleBackPage"></InfoHeader>
        </div>

        <div class="materialInfo-con pt10">
            <div class="left-info">
                <div class="wrap" v-show="show">
                    <div class="info-tabs">
                        <el-tabs v-model="activeName" stretch>
                            <el-tab-pane label="工单信息" name="info">
                                <span slot="label" class="font12px text-bold">工单信息</span>
                            </el-tab-pane>
                            <el-tab-pane label="工单流转" name="steps">
                                <span slot="label" class="font12px text-bold">工单流转</span>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="con" v-loading="info_loading">
                        <MaterialInfo :info="info" v-if="activeName == 'info'" />
                        <Materialsteps :stepsList="log" v-else />
                    </div>
                </div>
                <div class="wrap" v-show="!show">
                    <div class="empty-box"></div>
                </div>
                <div class="info-tabs-toggle" @click="handleToggle">
                    <i v-if="show" class="el-icon-caret-left"></i>
                    <i v-else class="el-icon-caret-right"></i>
                </div>
            </div>
            <div class="right-table">
                <el-row class="table-operations" :class="{ other: listType === 2 }" type="flex" justify="space-between"
                    align="middle">
                    <el-row class="operation-button" type="flex">
                        <el-button type="primary" v-if="getCurAuth('batch_upload_material') && tagsActive != 3" size="mini"
                            @click="handleBatchUpload">
                            批量上传
                            <el-tooltip
                                effect="dark"
                                content="按素材查看时，批量上传为全选任务上传。"
                                placement="bottom"
                            >
                            <i class="el-icon-question" style="font-size: 16px;"></i>
                            </el-tooltip>
                        </el-button>
                        <el-button type="danger" v-if="getCurAuth('batch_delete_material') && tagsActive != 3" size="mini" plain
                            @click="handleBatchDel">批量删除</el-button>
                        <el-button type="primary" size="mini" v-if="getCurAuth('upload_material') && listType == 2" plain
                            @click="handleBatchDownload">批量下载</el-button>
                    </el-row>
                    <el-row class="operation-contant" type="flex" justify="space-between" align="middle">
                        <el-row type="flex">
                            <div class="search-box custom-input">
                                <el-input size="mini" v-model="material_name" placeholder="请输入素材名称" @keyup.enter.native="
                                        handleSearch('', 'input')
                                    ">
                                    <template #prepend>
                                         <div class="pl4 pr4">
                                            <el-select
                                                size="mini"
                                                v-model="material_type"
                                                placeholder="请选择素材类型"
                                                style="width: 100px;"
                                            >
                                                <el-option
                                                    v-for="item in material_type_options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                />
                                            </el-select>
                                         </div>
                                    </template>
                                    <template #append>
                                        <i class="el-icon-search" @click="handleSearch('', 'input')"></i>
                                    </template>
                                </el-input>
                            </div>
                            <div class="search-box custom-input" v-if="listType === 2">
                                <span class="prepend">任务</span>
                                <ESelect size="mini" style="width: 240px;" :class="{ other: detail_id.length }" v-model="detail_id"
                                    placeholder="请选择任务" multiple collapse-tags clearable filterable
                                    @visible-change="(e) => handleSearch(e, 'visible')" @clear="handleSearch" @blur="handleSearch" @remove-tag="handleSearch">
                                    <el-option v-for="item in taskData" :key="item.id" :label="item.name"
                                        :value="item.id"/>
                                </ESelect>
                            </div>
                        </el-row>
                        <div class="table-list-type">
                            <el-radio-group v-model="listType" @change="changeListType" size="mini">
                                <el-radio-button :label="1">
                                    
                                    <el-tooltip
                                        effect="dark"
                                        content="按任务查看"
                                        placement="bottom"
                                    >
                                    <i class="el-icon-s-unfold" style="font-size: 16px;"></i>
                                    </el-tooltip>
                                </el-radio-button>
                                <el-radio-button :label="2">
                                    <el-tooltip
                                        effect="dark"
                                        content="素材查看"
                                        placement="bottom"
                                    >
                                    <i class="el-icon-menu" style="font-size: 16px;"></i>
                                    </el-tooltip>
                                </el-radio-button>
                            </el-radio-group>
                        </div>
                    </el-row>
                </el-row>
                <div class="con scrollbar-wrapper-78778965">
                    <el-table v-if="listType === 1" :data="tableData" :header-cell-style="{
                            background: '#e8eaec',
                            color: '#333',
                        }" style="width: 100%" size="mini" :key="curKey" ref="table" row-key="assign_id"
                        :expand-row-keys="expandRowKeys" @expand-change="expandChange"
                        @selection-change="handleSelectionChange" stripe>
                        <el-table-column type="selection" width="30" v-if="tagsActive != 3">
                        </el-table-column>
                        <el-table-column type="expand" width="40">
                            <template slot-scope="scope">
                                <MaterialsTableExpand :ref="'el_' + scope.row.assign_id"
                                    :hideProducerName="true" :orderId="scope.row.id" :rows="scope.row"
                                    :pageFuncNames="pageFuncNames" :show_status="show_status" :tagsActive="tagsActive"
                                    :info="info" :show-bar="show" @reloadColumn="handleReloadColumn" />
                            </template>
                        </el-table-column>
                        <el-table-column label="任务ID" prop="id" width="80">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.id }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作" width="80" v-if="tagsActive != 3">
                            <template slot-scope="scope">
                                <el-button type="primary" v-if="getCurAuth('upload_material')" size="mini"
                                    @click="handleUpload(scope.row)" :loading="scope.row.uploading"
                                    :disabled="scope.row.allow_upload_num <= 0">上传</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="被拒绝未修改" prop="material_num" width="95">
                            <template slot-scope="scope">
                                <div style="color: #ff0000; cursor: pointer" @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row["deny_no_update_num"] }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="(待上传，待审核，已通过) / 需求数量" prop="material_num" width="220">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    <div v-if="
                                            scope.row['material_status_num'] ==
                                            '-'
                                        ">
                                        {{ scope.row["material_status_num"] }}
                                    </div>
                                    <div v-else>
                                        <span style="
                                                color: #409eff;
                                                cursor: pointer;
                                            ">({{
                                            scope.row[
                                            "no_upload_material_num"
                                            ]
                                            }}</span>，
                                        <span style="
                                                color: #f56c6c;
                                                cursor: pointer;
                                            ">{{
                                            scope.row[
                                            "no_audit_material_num"
                                            ]
                                            }}</span>，
                                        <span style="
                                                color: rgb(103, 194, 58);
                                                cursor: pointer;
                                                padding-right: 5px;
                                            ">{{
                                            scope.row["pass_material_num"]
                                            }})</span>/
                                        <span style="">{{
                                            scope.row["material_num"]
                                            }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="制作人" prop="producer_name">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)" :title="scope.row.producer_name" class="ellipsis">
                                    {{ scope.row.producer_name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="制作完成日期" prop="finish_time" width="100">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.finish_time }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="任务紧急程度" prop="urgent_level" width="100">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    <span v-if="scope.row['urgent_level'] == 2" style="color: #ff0000">{{
                                        scope.row["urgent_level_text"]
                                        }}</span>
                                    <span v-else>{{
                                        scope.row["urgent_level_text"]
                                        }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="媒体" prop="plat_name" width="70">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.plat_name }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="素材格式" prop="material_format">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.material_format }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="素材尺寸">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    {{ scope.row.width }} *
                                    {{ scope.row.height }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="素材大小">
                            <template slot-scope="scope">
                                <div @click="toggleRowExpansion(scope.row)">
                                    <={{ scope.row.material_size }} {{ scope.row.material_size_unit }} </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <MaterialsTableExpand v-else ref="materialsRef" :orderId="order_id"
                        :params="{ [material_type]: material_name, detail_id }" :pageFuncNames="pageFuncNames" :show_status="show_status"
                        :tagsActive="tagsActive" :info="info" :show-bar="show" @reloadColumn="handleReloadColumn" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import InfoHeader from "@/views/workOrder/components/infoHeader.vue"
import MaterialExtendItem from "@/views/workOrder/components/materialExtendItem.vue"
import MaterialInfo from "./info.vue"
import Materialsteps from "@/views/workOrder/components/steps.vue"
import MaterialsTableExpand from "./tableExpand.vue"
import API from "@/api/workOrder/material.js"
import { rejectModal } from "./modal"
import { downLoadModal } from "../modalMaterial"
import {
    uploadMaterialModal,
    repeatSizeModal,
    taskUploadingModal,
} from "@/views/workOrder/modal"
import { countBy, find } from "lodash"
import { mapState, mapActions, mapMutations } from "vuex"
import matomoFun from "@/utils/matomo.js"
export default {
    name: "taskInfo",
    components: {
        MaterialExtendItem,
        InfoHeader,
        MaterialInfo,
        Materialsteps,
        MaterialsTableExpand,
    },
    props: {
        pageFuncNames: Array,
        query: {
            type: Object,
            default: function () {
                return {}
            },
        },
    },
    data() {
        return {
            show: true,
            activeName: "info",
            activeTableExpandName: "ready",
            info: [], //工单信息
            log: [], //工单流转
            multipleSelection: [],
            tableData: [],
            expandParams: {},
            expandRowKeys: [],
            curKey: 0,
            loading: false,
            info_loading: false,
            tagsActive: null,
            tags: [
                {
                    value: "1", // 2
                    label: "制作中",
                },
                {
                    value: "2", // 2
                    label: "待结单",
                },
                {
                    value: "3", // 4
                    label: "已完成",
                },
            ],
            show_type: false,
            show_status: "",
            order_id: "",
            outLock: false,
            lock: false,
            timer: 10,
            listType: 1,
            detail_id: [],
            material_name: "",
            taskData: [],
            material_type: "material_name",
            material_type_options: [
                {
                    value: 'material_name',
                    label: '素材名称'
                },
                {
                    value: 'material_md5',
                    label: '素材md5'
                },
            ]
        }
    },
    computed: {
        // 计算表格高度为视口高度减去160像素
        tableHeight() {
            return `calc(100vh - 212px)`
        },
        orderId() {
            let query = this.query || {}
            return query.order_id || query.id || ""
        },
        ...mapState({
            uploadQueue: (state) => state.workOrder.workTaskList,
        }),
    },
    watch: {
        query: {
            handler(n) {
                const { id, tagsActive, show_type } = n
                this.tagsActive = tagsActive
                this.show_type = show_type
                this.show_status = n?.show_status ? n?.show_status : ""
                this.order_id = id
                this.fetchInfo(id)
                this.fetchLog(id)
                this.fetchTaskData(id)
                setTimeout(() => {
                    this.fetchDetail(id)
                }, 120)

                // setTimeout(()=>{
                //     if(Object.keys(this.$route.query).length != 0) {
                //         this.$router.path({name:'work_order_material', query:{}})
                //     }
                // },100)
            },
            deep: true,
            immediate: true,
        },
        tagsActive: {
            handler(val) {
                // let name_list = this.tags.filter(item=>item.value == val)
                // let cur_name = '制作中'
                // if(name_list && name_list.length !== 0 && val) {
                //     cur_name = name_list[0].label
                // }
                this.CHANGE_BREADCRUMB(["任务管理", "工单详情"])
            },
            immediate: true,
        },
    },
    mounted() {},
    methods: {
        ...mapActions("workOrder", ["READ_ROUTE_LIST"]),
        ...mapMutations("app", ["CHANGE_BREADCRUMB"]),
        pushMatomo(name) {
            let cur_name = find(
                this.tags,
                (item) => item.value == this.query.tagsActive
            )
            let behaviorCategory = `素材工单(任务管理-${cur_name?.label})`
            matomoFun.trackEvent(behaviorCategory, "点击", name)
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name)
        },
        fetchInfo(id) {
            this.info_loading = true
            API.getWorkTaskInfo({ order_id: id })
                .then(
                    (res) => {
                        this.info = res.data
                        if (res.data.order_status == 4) {
                            this.tagsActive = 3
                        }
                    },
                    (err) => {
                        this.$message.error(err.info)
                    }
                )
                .finally(() => {
                    this.info_loading = false
                })
        },
        fetchTaskData(id) {
            API.getWorkTaskFilterData({ order_id: id }).then((res) => {
                this.taskData = res.data || []
            })
        },
        fetchLog(id) {
            API.getWorkTaskLog({ order_id: id }).then(
                (res) => {
                    this.log = res.data
                },
                (err) => {
                    this.$message.error(err.info)
                }
            )
        },
        fetchDetail(id) {
            if (this.listType === 1) {
                this.loading = true
                API.getWorkTaskDetailList({ order_id: id })
                    .then(
                        (res) => {
                            this.tableData = (res.data || []).map((item) => {
                                item.uploading = false
                                return item
                            })
                            this.curKey++
                            if (
                                this.show_type &&
                                this.show_type.toString() === "true"
                            ) {
                                this.$nextTick(() => {
                                    this.expandRowKeys = this.tableData.map(
                                        (item) => {
                                            return item.assign_id
                                        }
                                    )
                                    // this.expandRowKeys.forEach((item)=> {
                                    //     this.fetchMaterialList(item)
                                    // })
                                })
                            }
                        },
                        (err) => {
                            this.$message.error(err.info)
                        }
                    )
                    .finally(() => {
                        this.loading = false

                        this.whileFetch()
                    })
            } else {
                this.$nextTick(() => {
                    this.$refs.materialsRef.getInfo("init")
                })
            }
        },
        fetchMaterialList(id) {
            this.loading = true
            API.getWorkTaskMaterialList({ detail_id: id })
                .then(
                    (res) => {
                        this.expandParams = res.data
                        // this.$refs.table.toggleRowExpansion()
                    },
                    (err) => {
                        this.$message.error(err.info)
                    }
                )
                .finally(() => {
                    this.loading = false
                })
        },

        whileFetch() {
            if (this.outLock || this.lock) {
                return
            }
            this.timer = 10
            this.lock = true
            let time = null
            time = setInterval(() => {
                if (this.timer <= 0) {
                    clearInterval(time)
                    // this._updateListStatus()
                    if(this.listType == 2) {
                        this.$refs?.materialsRef?.getInfo("init", false)
                    }
                    API.getWorkTaskDetailList({ order_id: this.order_id })
                        .then(
                            (res) => {
                                let result_data = res.data
                                result_data.forEach((item) => {
                                    this.tableData.forEach((ele) => {
                                        if (ele.assign_id == item.assign_id) {
                                            this.$set(
                                                ele,
                                                "no_audit_material_num",
                                                item.no_audit_material_num
                                            )
                                            this.$set(
                                                ele,
                                                "no_upload_material_num",
                                                item.no_upload_material_num
                                            )
                                            this.$set(
                                                ele,
                                                "pass_material_num",
                                                item.pass_material_num
                                            )
                                            this.$set(
                                                ele,
                                                "deny_no_update_num",
                                                item.deny_no_update_num
                                            )
                                        }
                                    })
                                })
                                // this.curKey++
                                this.expandRowKeys.forEach((item) => {
                                    this.$refs[`el_${item}`] &&
                                        this.$refs[`el_${item}`].getInfo(
                                            "noinit",
                                            false
                                        )
                                })
                            },
                            (err) => {
                                // this.$message.error(err.info)
                            }
                        )
                        .finally(() => {
                            this.lock = false
                            this.whileFetch()
                        })
                } else {
                    --this.timer
                }
            }, 1000)
        },

        // 工单信息与流转 展开收起
        handleToggle() {
            this.show = !this.show
        },
        // 返回上一页
        handleBackPage() {
            this.pushMatomo("查看(返回)")
            this.curKey++
            if (window.history.length > 1) {
                this.$router.go(-1)
            } else {
                this.$router.replace({
                    name: "work_order_material",
                    query: {
                        topage: "TaskPage",
                    },
                    params: {
                        menuReload: 1,
                    },
                })
            }
        },

        // 展开行
        expandChange(row, expandeRows) {
            if (expandeRows && expandeRows.length !== 0) {
                this.expandRowKeys = expandeRows.map((item) => item.assign_id)
            }
        },
        toggleRowExpansion(row) {
            this.$refs.table.toggleRowExpansion(row)
        },
        handleSelectionChange(val) {
            console.log("handleSelectionChange", val)
            this.multipleSelection = val
        },
        // 单独上传
        handleUpload(row) {
            if (row.uploading) return console.log("多次点击")
            row.uploading = true
            API.getWorkTaskDetailList({
                assign_id: row.assign_id,
            }).then(
                (res0) => {
                    let resData0 = res0.data || []
                    resData0.forEach((item) => {
                        let actionItem = this.tableData.find(
                            (inner) => inner.assign_id == item.assign_id
                        )
                        this.$set(
                            actionItem,
                            "deny_no_update",
                            item.deny_no_update
                        )
                        this.$set(
                            actionItem,
                            "allow_upload_num",
                            item.allow_upload_num
                        )
                    })

                    API.checkBeforeUpload({
                        // order_id:this.orderId,
                        assign_id: row.assign_id,
                    }).then(
                        (res) => {
                            console.log("checkBeforeUpload", res)
                            let resData = res.data || {}
                            let denyList = (
                                resData.deny_no_update_list || []
                            ).map((item) => item.assign_id)
                            let list = (resData.list || []).filter((item) => {
                                return !denyList.includes(item.assign_id)
                            })
                            let errList = resData.err_list || []
                            let errMsg = resData.err_msg || []

                            if (errMsg.length > 0) {
                                row.uploading = false
                                // let errMsgText = errMsg.map(item=>item.info+'，任务ID：【'+(item.ids||[]).join('，')+'】').join(';');
                                // this.$message.error(errMsgText);
                                let errMsgText = errMsg
                                    .map((item) => {
                                        let isHasId =
                                            (item.ids || []).length > 0
                                        if (isHasId) {
                                            return (
                                                '<p style="line-height: 20px;">' +
                                                item.info +
                                                "<br/>任务ID：" +
                                                (item.ids || []).join("，") +
                                                "</p>"
                                            )
                                        } else {
                                            return (
                                                '<p style="line-height: 20px;">' +
                                                item.info +
                                                "</p>"
                                            )
                                        }
                                    })
                                    .join("")
                                this.$message.error({
                                    message: errMsgText,
                                    dangerouslyUseHTMLString: true,
                                })
                            } else if (errList.length > 0) {
                                row.uploading = false
                                const { vm } = taskUploadingModal({
                                    props: {
                                        list: errList,
                                    },
                                    cbs: {
                                        onSubmit: () => {
                                            console.log("触发详情关闭,继续上传")
                                            if (list.length > 0) {
                                                this.submitBatchUpload(list)
                                            } else {
                                                this.$message.error(
                                                    "该任务暂无可上传素材数量"
                                                )
                                            }
                                        },
                                        onClose: () => {
                                            vm.close()
                                        },
                                    },
                                })
                            } else if (list.length > 0) {
                                let taskList = [
                                    Object.assign(
                                        {},
                                        { order_id: this.orderId },
                                        row
                                    ),
                                ]
                                row.uploading = false
                                this.pushMatomo("列表(查看-上传)")
                                let cur_name = find(
                                    this.tags,
                                    (item) =>
                                        item.value == this.query.tagsActive
                                )
                                let behaviorCategory = `素材工单(任务管理-${cur_name?.label})`
                                const { vm } = uploadMaterialModal({
                                    props: {
                                        title: "素材上传",
                                        taskList: taskList,
                                        orderInfo: { ...this.info },
                                        isBatch: false,
                                        behaviorCategory: behaviorCategory,
                                        name: "列表(查看-上传-上传)",
                                    },
                                    cbs: {
                                        onSubmit: (data) => {
                                            console.log("触发详情关闭1", data)
                                            this.$store.commit(
                                                "workOrder/ADD_WORK_TASK_ITEM",
                                                data
                                            )
                                        },
                                    },
                                    on: {
                                        close: () => {
                                            vm.close()
                                            this.pushMatomo(
                                                "列表(查看-上传-取消)"
                                            )
                                        },
                                    },
                                })
                            } else {
                                row.uploading = false
                                this.$message.error("该任务暂无可上传素材数量")
                            }
                        },
                        (err) => {
                            console.log("checkBeforeUpload err", err)
                            row.uploading = false
                            this.$message.error(err.info || "请求异常")
                        }
                    )
                },
                (err0) => {
                    row.uploading = false
                    this.$message.error(err0.info || "请求异常")
                }
            )
        },
        // 批量上传
        handleBatchUpload() {
            console.log('000000', this.listType, this.multipleSelection.length, this.tableData.length)
            if (this.listType == 1 && this.multipleSelection.length == 0) {
                return this.$message.error("请选择需要上传的任务")
            }else if(this.listType == 2 && this.tableData.length == 0) {
                return this.$message.error("请选择需要上传的任务")
            }else if(!this.listType && this.multipleSelection.length == 0) {
                return this.$message.error("请选择需要上传的任务")
            }
            if (this.batchUploadLoading) return console.log("多次点击")
            this.batchUploadLoading = true

            this.pushMatomo("列表(查看-批量上传)")

            let assign_id = this.listType == 1 ? this.multipleSelection.map(item=>item.assign_id) : this.tableData.map(item=>item.assign_id)
            
            API.getWorkTaskDetailList({
                assign_id: assign_id?.join(","),
            }).then(
                (res0) => {
                    let resData0 = res0.data || []
                    resData0.forEach((item) => {
                        let actionItem = this.tableData.find(
                            (inner) => inner.assign_id == item.assign_id
                        )
                        this.$set(
                            actionItem,
                            "allow_upload_num",
                            item.allow_upload_num
                        )
                    })

                    API.checkBeforeUpload({
                        order_id: this.orderId,
                        assign_id: assign_id,
                    }).then(
                        (res) => {
                            console.log("checkBeforeUpload", res)
                            let resData = res.data || {}
                            let denyList = (
                                resData.deny_no_update_list || []
                            ).map((item) => item.assign_id)
                            let list = (resData.list || []).filter((item) => {
                                return !denyList.includes(item.assign_id)
                            })
                            let errList = resData.err_list || []
                            let errMsg = resData.err_msg || []

                            if (errMsg.length > 0) {
                                this.batchUploadLoading = false
                                // let errMsgText = errMsg.map(item=>item.info+'，任务ID：【'+(item.ids||[]).join('，')+'】').join(';');
                                // this.$message.error(errMsgText);
                                let errMsgText = errMsg
                                    .map((item) => {
                                        let isHasId =
                                            (item.ids || []).length > 0
                                        if (isHasId) {
                                            return (
                                                '<p style="line-height: 20px;">' +
                                                item.info +
                                                "<br/>任务ID：" +
                                                (item.ids || []).join("，") +
                                                "</p>"
                                            )
                                        } else {
                                            return (
                                                '<p style="line-height: 20px;">' +
                                                item.info +
                                                "</p>"
                                            )
                                        }
                                    })
                                    .join("")
                                this.$message.error({
                                    message: errMsgText,
                                    dangerouslyUseHTMLString: true,
                                })
                            } else if (errList.length > 0) {
                                const { vm } = taskUploadingModal({
                                    props: {
                                        list: errList,
                                    },
                                    cbs: {
                                        onSubmit: () => {
                                            console.log("触发详情关闭,继续上传")
                                            this.batchUploadLoading = false
                                            if (list.length > 0) {
                                                this.submitBatchUpload(list)
                                            } else {
                                                this.$message.error(
                                                    "该任务暂无可上传素材数量"
                                                )
                                            }
                                        },
                                        onClose: () => {
                                            vm.close()
                                            this.batchUploadLoading = false
                                        },
                                    },
                                })
                            } else if (list.length > 0) {
                                this.batchUploadLoading = false
                                this.submitBatchUpload(list)
                            } else {
                                this.batchUploadLoading = false
                                this.$message.error("该任务暂无可上传素材数量")
                            }
                        },
                        (err) => {
                            this.batchUploadLoading = false
                            console.log("checkBeforeUpload err", err)
                            this.$message.error(err.info || "请求异常")
                        }
                    )
                },
                (err0) => {
                    this.$message.error(err0.info || "请求异常")
                }
            )
        },
        submitBatchUpload(list) {
            let newMulti = this.listType == 1 ? this.multipleSelection : this.tableData
            let rawTaskList = newMulti
                .map((item) => {
                    item.order_id = this.orderId
                    return item
                })
                .filter((item) => {
                    // 过滤掉不在list里的数据
                    return list
                        .map((inner) => inner.assign_id)
                        .includes(item.assign_id)
                })
                .filter((item) => {
                    // 过滤掉上传队列里的数据
                    return !this.uploadQueue.find(
                        (inner) => item.assign_id == inner.assign_id
                    )
                })
                .filter((item) => item.allow_upload_num > 0)

            if (rawTaskList.length <= 0)
                return this.$message.error("该任务暂无可上传素材数量")

            let sizeCountMap = countBy(
                rawTaskList,
                (item) => item.width + "*" + item.height
            )
            let repeatSize = [] // 存在重复的尺寸
            let noRepeatSize = [] // 不重复的尺寸
            for (let size in sizeCountMap) {
                if (sizeCountMap[size] > 1) {
                    repeatSize.push(size)
                } else {
                    noRepeatSize.push(size)
                }
            }

            if (repeatSize.length > 0) {
                console.log(
                    "show repeatSizeModal",
                    rawTaskList,
                    repeatSize,
                    list
                )
                repeatSizeModal({
                    props: {
                        title: "温馨提示",
                        taskList: rawTaskList,
                        repeatList: repeatSize,
                    },
                    cbs: {
                        onSubmit: (sizeData) => {
                            let taskList = noRepeatSize
                                .map((item) => {
                                    return rawTaskList.find(
                                        (inner) =>
                                            inner.width + "*" + inner.height ===
                                            item
                                    )
                                })
                                .concat(
                                    repeatSize.map((item) => {
                                        return rawTaskList.find(
                                            (inner) =>
                                                inner.width +
                                                    "*" +
                                                    inner.height ===
                                                    item &&
                                                inner.assign_id ==
                                                    sizeData[item]
                                        )
                                    })
                                )
                            let cur_name = find(
                                this.tags,
                                (item) => item.value == this.query.tagsActive
                            )
                            let behaviorCategory = `素材工单(任务管理-${cur_name?.label})`
                            const { vm } = uploadMaterialModal({
                                props: {
                                    title: "素材上传",
                                    taskList: taskList,
                                    orderInfo: { ...this.info },
                                    isBatch: true,
                                    behaviorCategory: behaviorCategory,
                                    name: "列表(查看-批量上传-上传)",
                                },
                                cbs: {
                                    onSubmit: (data) => {
                                        console.log("触发详情关闭2", data)
                                        this.$store.commit(
                                            "workOrder/ADD_WORK_TASK_ITEM",
                                            data
                                        )
                                    },
                                },
                                on: {
                                    close: () => {
                                        vm.close()
                                        this.pushMatomo(
                                            "列表(查看-批量上传-取消)"
                                        )
                                    },
                                },
                            })
                        },
                    },
                })
            } else {
                const { vm } = uploadMaterialModal({
                    props: {
                        title: "素材上传",
                        taskList: rawTaskList,
                        orderInfo: { ...this.info },
                        isBatch: true,
                    },
                    cbs: {
                        onSubmit: (data) => {
                            console.log("触发详情关闭3", data)
                            this.$store.commit(
                                "workOrder/ADD_WORK_TASK_ITEM",
                                data
                            )
                        },
                    },
                    on: {
                        close: () => {
                            vm.close()
                            this.pushMatomo("列表(查看-批量上传-取消)")
                        },
                    },
                })
            }
        },
        // 批量删除
        handleBatchDel() {
            if(this.listType == 2){
                // 按素材
                this.$refs.materialsRef.handleGroupReject('group')
                return
            }

            if (this.multipleSelection.length == 0) {
                return this.$message.error("请选择素材")
            }
            let res_assign_id = this.multipleSelection.map(
                (item) => item.assign_id
            )
            this.pushMatomo("列表(查看-批量删除)")
            let cur_name = find(
                this.tags,
                (item) => item.value == this.query.tagsActive
            )
            let behaviorCategory = `素材工单(任务管理-${cur_name?.label})`
            const { vm } = rejectModal({
                props: {
                    fetch: "postWorkTaskBatchDeleteExpand",
                    postItems: { assign_id: res_assign_id },
                    name: behaviorCategory,
                    desc: "列表(查看-批量删除-",
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                        this.$refs?.table?.clearSelection()
                        this.fetchDetail(this.orderId)
                    },
                },
                on: {
                    close: () => {
                        vm.close()
                        this.pushMatomo("列表(查看-批量删除-取消)")
                    },
                },
            })
        },
        //更新单个column
        handleReloadColumn(assign_id) {
            API.getWorkTaskDetailList({ order_id: this.order_id }).then(
                (res) => {
                    let currentIndex = res.data.findIndex(
                        (item) => item.assign_id == assign_id
                    )
                    if (currentIndex !== -1) {
                        this.$set(
                            this.tableData,
                            currentIndex,
                            res.data[currentIndex]
                        )
                    }
                },
                (err) => {
                    this.$message.error(err.info)
                }
            )
            this.$refs.table.clearSelection()
        },
        // 批量下载
        handleBatchDownload() {
            if (this.listType === 1) {
                if (!this.multipleSelection.length) {
                    return this.$message.warning("请选择任务")
                }
                const detailIds = this.multipleSelection.map((row) => row.id) // 提取选中任务的ID
                const { vm } = downLoadModal({
                    props: {
                        orderId: [this.order_id],
                        detailId: detailIds, // 传递任务ID数组给下载弹框
                    },
                    cbs: {
                        onSubmit: () => {
                            vm.close()
                        },
                    },
                })
            } else {
                this.$refs.materialsRef.handleGroupDown()
            }
        },
        changeListType() {
            this.multipleSelection = []
            // this.listType = this.listType === 1 ? 2 : 1
        },
        handleSearch(e, status) {
            if (status === "visible" && e === true) return
            this.multipleSelection = []
            if (status === "input" && this.material_name) {
                this.listType = 2
            }
            // if (status === "input" && !this.material_name && !this.detail_id.length) {
            //     this.listType = 1
            // }
            this.fetchDetail(this.order_id)
        },
    },
    deactivated() {
        this.outLock = true
        console.log("deactivated", this.outLock)
    },
    beforeDestroy() {
        this.outLock = true
        console.log("beforeDestroy", this.outLock)
    },
}
</script>
<style lang="scss" scoped>
.materialInfo {
    width: 100%;
    ::v-deep .el-table::before {
            display: none;
        }
    .materialInfo-con {
        height: calc(100vh - 100px);
        width: 100%;
        display: flex;
        justify-content: space-between;
        .left-info {
            height: 100%;
            margin-right: 10px;
            position: relative;
            .info-tabs-toggle {
                position: absolute;
                right: -10px;
                top: 50%;
                transform: translateY(-50%);
                width: 10px;
                height: 80px;
                background-color: #409eff;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                i {
                    color: #fff;
                }
            }
            .wrap {
                display: flex;
                flex-direction: column;
                height: 100%;
                .info-tabs {
                    background-color: #fff;
                    width: 100%;
                    text-align: center;
                }
                .con {
                    background-color: #fff;
                    width: 200px;
                    padding: 0 6px;
                    height: 0;
                    flex: 1;
                    overflow: auto;
                }
            }
            ::v-deep .el-tabs__item {
                line-height: 45px;
                height: 45px;
            }
        }
        .right-table {
            flex: 1;
            padding: 8px;
            background: #fff;
            overflow-x: hidden;
            height: 100%;
            display: flex;
            flex-direction: column;
            .con {
                background-color: #fff;
            height: 100%;
                flex: 1;
                overflow: hidden;
                > div {
                    height: 100%;
                    overflow: auto;
                }
            }
            ::v-deep .el-table__expanded-cell {
                background-color: #f2f2f2 !important;
            }
            .table-operations {
                flex-wrap: wrap;
                padding-bottom: 2px;
                background-color: #fff;

                > .el-row {
                    margin-bottom: 8px;
                }

                .operation-button {
                    margin-right: 8px;
                }

                .operation-contant {
                    flex: auto;

                    .search-box {
                        // width: 220px;
                        height: 30px;
                        display: flex;
                        align-items: center;
                        ::v-deep .el-input-group__prepend {
                            padding: 0 10px;

                            &::after {
                                border-color: #dcdfe6 !important;
                            }
                        }

                        ::v-deep .el-input-group__append {
                            cursor: pointer;
                            padding: 0 8px;
                            background: #f5f7fa !important;
                        }

                        .other {
                            ::v-deep .el-tag {
                                max-width: calc(100% - 30px) !important;
                            }

                            ::v-deep .el-select__input {
                                padding: 0 4px !important;
                                margin-left: 4px !important;
                                max-width: 30px !important;
                            }
                        }
                    }

                    .custom-input {
                        margin-right: 10px;
                    }

                    .prepend {
                        flex: 1 0 auto;
                        height: 100%;
                        line-height: 28px;
                        &::after {
                            border-color: #dcdfe6 !important;
                        }
                    }
                }

                .table-list-type {
                    text-align: center;

                    img {
                        height: 20px;
                        cursor: pointer;
                        transition: transform 0.3s ease;

                        &:hover {
                            transform: scale(1.2);
                        }
                    }
                }

                &.other {
                    margin-bottom: 4px;
                    border-bottom: 1px solid #dcdfe6;
                }
            }
        }
        .empty-box {
            width: 3px;
            border: solid 1px #ccc;
            height: 100%;
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    width: 200px;
    opacity: 1;
    transition: all 0.6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    width: 0;
    opacity: 0;
}

.material-table-expand {
    padding: 0 10px;
    .material-table-expand-con {
        //background-color: #F1F4F9;
    }
    .material-table-expand-header {
        display: flex;
        flex-wrap: wrap;
        span {
            padding-right: 20px;
            padding-bottom: 6px;
        }
    }
    .material-table-expand-cards {
        display: flex;
        flex-wrap: wrap;
        .pad-material-table-expand-cards-item {
            background-color: transparent !important;
            width: 300px;
        }
        .material-table-expand-cards-item {
            background-color: #fff;
            margin: 0 5px 10px 5px;
        }
    }
    .tabsMini {
        background-color: #fff;
        padding-left: 20px;
        .el-tabs__item {
            font-size: 12px;
            line-height: 30px;
            height: 30px;
        }
    }
}
::v-deep .el-table-column--selection .cell {
    padding-left: 8px !important;
    padding-right: 8px !important;
}
</style>
